import React from "react";
import "./SecureFooter.scss";
import { useLayoutEffect, useRef, useState } from "react";
import {
  I2cFooter,
  I2cBrand,
} from "@webcomponents/i2cwebcomponents/dist/react";
const SecureFooter = ({ containerClass = "" }) => {
  const currentYear = new Date().getFullYear();
  return (
    <React.Fragment>
      <div className={`footerCustom ${containerClass}`}>
        <p> i2c Inc. © {currentYear} All Rights Reserved.</p>
      </div>
    </React.Fragment>
  );
};

export default SecureFooter;
